import { IDs } from '../../../helpers/IDs';

export function getBasisjahr(data: any, dataGlobal: any): number {
    const kennzahlen: any = (dataGlobal || {})[IDs.KENNZIFFERN_BERECHNET] || {};
    data = data || {};

    return +Object.keys(kennzahlen)
        .filter((jahr: string) => !isNaN(+jahr))
        .sort()
        .reverse()
        .find((jahr: string) => kennzahlen[jahr][data.vKey] && kennzahlen[jahr][data.kKey]) || null;
}

export function getParameter(data: any): any {
    return JSON.parse((((data || {})[IDs.ENT_ENERGIEKOSTEN_PROJEKTION] || [])[0] || {}).parameter || '{}');
}

export function getPreisVars(data: any): any {
    data = data || {};
    const startJahr: number = +Object.keys(data).find((jahr) => data[jahr]) || null;
    const startPreis: number = data[startJahr];
    const endJahr: number = +Object.keys(data).reverse().find((jahr) => data[jahr]) || null;
    const endPreis: number = data[endJahr];
    const diffJahre: number = (+endJahr - +startJahr) || 0;
    const diffPreis: number = (+endPreis - +startPreis) || 0;
    const chunkPreis: number = diffJahre > 0 ? diffPreis / diffJahre : 0;

    return { startPreis, endPreis, diffPreis, chunkPreis, startJahr, endJahr, diffJahre };
}

export function transformValue(value: number, decimalPlaces: number): number {
    const num: number = 10 ** decimalPlaces;

    if (isNaN(+value)) {
        return null;
    }

    return Math.round(value * num) / num;
}
